module.exports = __webpack_public_path__ + "img/scene-rehearsal-stage.f87ebb54.jpg";